import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Donor } from "types";
import {
  fetchCampaignDonors
} from "./campaignDonors.actions";
import { initialState } from "./campaignDonors.initial-state";


const campaignDonorsSlice = createSlice({
  name: "campaignDonors",
  initialState,
  reducers: {
    setCampaignDonors: (state, action: PayloadAction<Donor[]>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaignDonors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaignDonors.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchCampaignDonors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch donors";
      })
  },
});

export const {setCampaignDonors } = campaignDonorsSlice.actions;
const campaignDonorsReducer = campaignDonorsSlice.reducer;
export default campaignDonorsReducer;
